import { Alert, AlertProps, Collapse } from "@mui/material";
import AlertTitle from "@mui/material/AlertTitle";
import { useState } from "react";

export interface AlertBannerProps extends AlertProps {
	severity:
		| "success"
		| "warning"
		| "error"
		| "info"
		| "recommendation"
		| "neutral";
	title?: string;
	children?: React.ReactNode;
	actionText?: string;
	actionOnClick?: () => void;
	actionDisabled?: boolean;
	closeable?: boolean;
	onClose?: () => void;
}

const VARIANT_MAP = { recommendation: "outlined" };

function AlertBanner({
	severity,
	title,
	children,
	actionText,
	actionOnClick,
	actionDisabled,
	closeable,
	onClose,
	...rest
}: AlertBannerProps) {
	const [open, setOpen] = useState(true);

	return (
		<Collapse in={open} className="full-w">
			<Alert
				severity={severity}
				variant={VARIANT_MAP[severity] ?? "standard"}
				onClose={
					closeable
						? () => {
								setOpen(false);
								onClose?.();
							}
						: undefined
				}
				{...rest}
			>
				{title ? <AlertTitle>{title}</AlertTitle> : undefined}
				{children}
				{actionText ? (
					<>
						{" "}
						<button
							className="body2 link-text1 link pl-1"
							onClick={actionOnClick ? () => actionOnClick() : undefined}
							disabled={actionDisabled}
						>
							<strong>{actionText}</strong>
						</button>
					</>
				) : undefined}
			</Alert>
		</Collapse>
	);
}

export default AlertBanner;
